import formularioAction from './formulario.action'
import clienteAction from './cliente.action'
import pessoaAction from './pessoa.action'

export default {
    ...formularioAction,
    ...clienteAction,
    ...pessoaAction
}


// WEBPACK FOOTER //
// ./src/store/actions/index.js